import { useEffect } from "react";

// Some designs (06 passengers, 07 reprice, 08 payment, 10 my-bookings,
// 11 booking-detail) set `body { background: var(--bg-2) }` in their
// local <style>. Mirror that by toggling a class for the lifetime of the
// page; pages.css defines `body.has-bg2` to swap the background.
export function useBodyClass(cls: string) {
  useEffect(() => {
    document.body.classList.add(cls);
    return () => document.body.classList.remove(cls);
  }, [cls]);
}
